import styles from './BetaBadge.module.css';

// Метка раздела, который ещё обкатывают: подсказка объясняет, чего ждать.
export function BetaBadge() {
  return (
    <span className={styles.badge} title="Раздел в бета-версии: возможны ошибки и изменения">
      Beta
    </span>
  );
}
